import React, { useContext, useEffect, useRef, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { FaSearch } from "react-icons/fa";
import { BiHistory } from "react-icons/bi";
import { DContext } from '../../../context/Datacontext';
import { createProfileAction, fetchPaginationProfile, fetchProfile, deleteProfileAction } from '../../services/profileAction';
import { formatNames } from '../../../utils/formatNames';
import ProfileSubmission from './ProfileSubmission';
import { fetchUpdateJob } from '../../services/fetchUpdateJob';
import { RiDeleteBin2Line } from "react-icons/ri";
import ProfileHistoryList from './ProfileHistoryList';


export const ProfileActionList = () => {

    const { BeURL, showAlert, currentUser } = useContext(DContext)
    const [allProfiles, setAllProfiles] = useState(null)
    const searchRef = useRef();
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalProfiles, settotalProfiles] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [deletionLoading, setDeletionLoading] = useState(false);
    const [isPipeline, setPipeline] = useState(false)
    const [type, setType] = useState('submission')
    const [processType, setProcessType] = useState('')
    const [candidateId, setCandidateId] = useState('')
    const [job, setJob] = useState(null)

    // Move to Submission to Pipeline
    // const  [pipe, setPipe] = useState(false)


    // History
    const [profileHistory, setProfileHistory] = useState([])
    const [showSubmission, setShowSubmission] = useState(false)

    const navigate = useNavigate()
    const location = useLocation()
    const search = new URLSearchParams(location.search);


    const jobId = search.get('jobId');

    const fetchProfiles = async () => {
        await fetchPaginationProfile(BeURL, showAlert, jobId, currentPage, searchTerm, itemsPerPage, type,
            setAllProfiles, setTotalPages, settotalProfiles
        )
    }

    // Fetch Job

    useEffect(() => {
        const getJob = async () => {
            await fetchUpdateJob(BeURL, jobId, showAlert, setJob)
        }
        getJob()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobId, BeURL])


    useEffect(()=>{

    }, [allProfiles])


    // Fetch candidates when page, searchTerm, or itemsPerPage changes
    useEffect(() => {

        if (currentPage <= totalPages) {
            fetchProfiles();
        }
        else {
            setCurrentPage(1)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, itemsPerPage, BeURL]);

    useEffect(() => {
        if (searchTerm === "") {
            fetchProfiles()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm])

    useEffect(() => {
        setCurrentPage(1)
    }, [itemsPerPage])

    useEffect(() => {
        fetchProfiles()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [processType])

    const handlePagination = (dir) => {
        if (dir === 'prev' && currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
        if (dir === 'next' && currentPage < totalPages) {
            setCurrentPage(prev => prev + 1);
        }
    };

    const handleSearch = () => {
        setCurrentPage(1);
        fetchProfiles()
    }

    const handleKeyDown = (e) => {

        if (e.key === "Enter") {
            handleSearch()
        }
    }

    useEffect(() => {
        fetchProfiles()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type])

    // Toggle set
    const handleToggle = () => {
        setPipeline(prev => !prev);
    };

    // update type whenever isPipeline changes
    useEffect(() => {
        setType(isPipeline ? 'pipeline' : 'submission');
    }, [isPipeline]);

    // History methods
    const handleHistory = async (id) => {
        await fetchProfile(BeURL, showAlert, setProfileHistory, jobId, id)
    }

    const handleProfileAction = async (id, type, action) => {
        setProcessType(type)
        setCandidateId(id)

        if (type === 'pipeline') {
            const payload = {
                "jobId": jobId,
                "candidateId": id,
                "type": type,

            }
            const success = await createProfileAction(BeURL, showAlert, payload)

            if (success) {
                await fetchProfiles()
            }

        }
        else if (type === 'submission' && action === 'pipeline') {
            const payload = {
                "jobId": jobId,
                "candidateId": id,
                "type": type,

            }
            payload.status = 'waiting for evaluation'


            const success = await createProfileAction(BeURL, showAlert, payload)

            if (success) {
                await fetchProfiles()
            }

        }
        else {
            setShowSubmission(true)
        }
    }

    const handleProfileDeletion = (candidateId) => {
        deleteProfileAction(BeURL, showAlert, setDeletionLoading, jobId, candidateId)
    }
    console.log("UserId", currentUser)
    // Access control for Edit button
    const getAccess = (job, pro) => {
        if (job?.primaryRecruiter?.email === currentUser?.email) return true;
        if (job?.reportingTeamLead?.email === currentUser?.email) return true;
        if (job?.reportingManager?.email === currentUser?.email) return true;
        if (job?.reportingManager?.email === currentUser?.email) return true;
        job?.assignedTo.forEach(ids => {
            if (ids.email === currentUser?.email)
                return true
        }
        )
        if (pro?.actionHistory[0]?.user?.id === currentUser?._id) return true


        if (['admin'].includes(currentUser?.role)) return true;
        return false;
    }


    // useEffect(() => {

    // }, [candidateId, processType === ''])



    // if (profileHistory.length === 0) return <NotFound />;
    console.log("Jobss:-", job)
    return (
        <div className='min-h-[90vh] space-y-4 m-3 px-4 md:px-10'>


            <h2 className="text-2xl font-semibold mb-4 text-gray-800 text-center">Profile Actions</h2>

            <div className='md:px-14'>
                <div className='flex justify-between flex-wrap'> <h3 className='font-semibold '>Job Title :  <span className='text-primary-500 '> {formatNames(job?.title)}</span></h3>
                    <h3 className='font-semibold  md:w-[400px]'>Job Code : <span className='text-primary-500 '>{formatNames(job?.internalJobId)}</span></h3></div>

                <div className='flex justify-between flex-wrap mt-4'> <h3 className='font-semibold '>Skills :  {job?.skills?.slice(0, 5)?.map(skill => (<span key={skill} className={`text-primary-500`}> {formatNames(skill)}, </span>))}
                    {job?.skills?.length > 5 && <span className="text-gray-500"> ...</span>} </h3>
                    <div className=' flex gap-2 md:w-[400px]'>
                        <h3 className='font-semibold'>Description:</h3>
                        <div className='text-primary-500 line-clamp-3 break-words' dangerouslySetInnerHTML={{ __html: job?.description }} />
                    </div>

                </div>

            </div >

            {/* Toggle set */}
            < div className="flex items-center gap-3 justify-center pt-3" >
                {/* Candidate Profile text */}
                < span
                    className={`${isPipeline ? "text-primary-500 font-bold" : "text-gray-400"
                        }`}
                >
                    Pipeline
                </span >

                {/* Toggle button */}
                < button
                    onClick={() => handleToggle()}
                    className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ${isPipeline
                        ? "bg-primary-500 justify-start"
                        : "bg-secondary-500 justify-end"
                        }`}
                >
                    <div className="w-5 h-5 bg-white rounded-full shadow-md"></div>
                </button >
                {/* New Users text */}
                < span
                    className={`${!isPipeline ? "text-secondary-500 font-bold" : "text-gray-400"
                        }`}
                >
                    Submission
                </span >
            </div >

            {/* Search & Create */}
            < div className="flex flex-wrap gap-4" >
                <div className="flex flex-1 max-w-md ">

                    <input
                        ref={searchRef}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        type="search"

                        className="flex-1 border rounded-l px-3 py-2 focus:outline-none"
                        placeholder="Search by role, skill, exp..."
                        onKeyDown={e => handleKeyDown(e)}
                    />
                    <button onClick={handleSearch} className={`px-4 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-white rounded-r flex items-center`}
                        title="Apply search">
                        <FaSearch className="mr-2" />Search
                    </button>
                </div>
            </div >

            {/* Scrollable Table */}
            < div className="overflow-x-auto bg-white rounded-xl shadow-md" >
                <div className=" overflow-y-auto">
                    <table className="min-w-full border-collapse">
                        <thead className="bg-primary-400 text-white sticky top-0 z-10">
                            <tr>
                                <th className="p-3">S.No</th>
                                {/* <th className="p-3 ">Candidate ID</th> */}
                                <th className="p-3 ">Candidate Name</th>
                                <th className="p-3 ">Email</th>
                                <th className="p-3 ">Contact</th>
                                <th className="p-3 ">Recent Status</th>
                                <th className="p-3 ">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allProfiles?.length > 0 ? (
                                allProfiles
                                    .filter((pro) => {
                                        const actions = pro?.actionHistory || [];
                                        if (actions.length === 0) return false;

                                        const latestAction = [...actions].sort(
                                            (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                                        )[0]?.type;

                                        //  Filter by tab type
                                        if (type === "pipeline") return latestAction === "pipeline";
                                        if (type === "submission") return latestAction === "submission";
                                        return false;
                                    })
                                    .map((pro, idx) => {
                                        const actions = pro?.actionHistory || [];
                                        const statuses = pro?.statusHistory || [];

                                        //  Get latest action
                                        const latestAction = [...actions].sort(
                                            (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                                        )[0];


                                        //  Get latest status (for submission)
                                        const latestStatus = [...statuses].sort(
                                            (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                                        )[0];

                                        return (
                                            <tr
                                                key={pro._id}
                                                className="hover:bg-blue-50 transition border-b border-slate-100"
                                            >
                                                <td className="p-3 text-center">{idx + 1}</td>

                                                <td
                                                    className="p-3 text-primary-500 cursor-pointer font-medium"
                                                    onClick={() => navigate(`/candidate/${pro.candidate.id}`)}
                                                >
                                                    {pro.candidate.name || "-"}
                                                </td>

                                                <td className="p-3">{pro.candidate.email || "-"}</td>
                                                <td className="p-3">
                                                    +{pro.candidate.contact?.countryCode} {pro.candidate.contact?.number}
                                                </td>

                                                {/* ✅ Show latest pipeline or submission info */}
                                                <td className="p-3 text-center">
                                                    {type === "pipeline"
                                                        ? formatNames(latestAction?.type)
                                                        : formatNames(latestStatus?.status?.statusLabel) || "-"}
                                                </td>

                                                <td className={`p-3 flex items-center gap-2 ${getAccess(job, pro) ? 'justify-between' : 'justify-center'}`}>
                                                    <BiHistory
                                                        className="text-secondary-400 text-xl cursor-pointer"
                                                        title="View History"
                                                        onClick={() => handleHistory(pro.candidate.id)}
                                                    />

                                                    {/* Show pipeline button only when not already pipeline */}
                                                    {type !== "pipeline" &&
                                                        (getAccess(job, pro)) &&
                                                        (
                                                            <button
                                                                className="border font-medium rounded-lg px-2 py-1 transition shadow-lg cursor-pointer text-primary-400 hover:bg-primary-200 hover:text-white"
                                                                onClick={() => handleProfileAction(pro.candidate.id, "pipeline")}
                                                            >
                                                                Push to Pipeline
                                                            </button>
                                                        )}

                                                    {console.log("pro", pro)}

                                                    {
                                                        (getAccess(job, pro)) &&
                                                        (
                                                            <><button
                                                                className="border font-medium rounded-lg px-1 py-1 transition shadow-lg cursor-pointer bg-primary-200 text-white"
                                                                onClick={() => handleProfileAction(pro.candidate.id, "submission", latestAction.type)}
                                                            >
                                                                {type === 'pipeline' ? 'Push to Submission' : 'Update Status'}
                                                            </button>

                                                                {/* {console.log("CurrentUser :", currentUser, "Pro:", pro.actionHistory[0].user.id)} */}
                                                                {
                                                                    (getAccess(job, pro)) &&
                                                                    <button disabled={deletionLoading} className={`text-red-600 mx-2 text-lg ${deletionLoading ? 'cursor-wait' : 'cursor-pointer'}`} title='Delete Candidate from list'
                                                                        onClick={() => handleProfileDeletion(pro.candidate.id)}>
                                                                        <RiDeleteBin2Line />
                                                                    </button>
                                                                }
                                                            </>
                                                        )}
                                                </td>
                                            </tr>
                                        );
                                    })
                            ) : (
                                <tr className="text-center text-black">
                                    <td colSpan={6}>No Data Found</td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>
            </div >


            {/* Pagination Controls */}
            < div className="mx-auto my-4 flex justify-between items-center" >
                <div className="flex items-center gap-2">
                    <label htmlFor="recordsPerPage" className="text-sm">Records per page:</label>
                    <select
                        id="recordsPerPage"
                        value={itemsPerPage}
                        onChange={e => setItemsPerPage(parseInt(e.target.value, 10))}
                        className="ml-2 px-3 py-1 border rounded"
                    >
                        {[5, 10, 20, 30].map(n => (
                            <option key={n} value={n}>{n}</option>
                        ))}
                    </select>
                </div>

                <div className="flex justify-center items-center gap-4 ">

                    <button className={`px-3 py-1 bg-white border rounded disabled:opacity-50`}
                        onClick={() => handlePagination('prev')}
                        disabled={currentPage === 1}
                    >
                        Prev
                    </button>

                    <span> Page {currentPage} of {totalPages}</span>

                    <button className={`px-3 py-1 bg-white border rounded disabled:opacity-50`}
                        onClick={() => handlePagination('next')}
                        disabled={currentPage === totalPages || totalPages === 0}
                    >
                        Next
                    </button>
                </div>
                <div className="text-sm">Total Profiles: {totalProfiles}</div>
            </div >


            {/* history data */}
            {
                profileHistory?.length > 0 && <ProfileHistoryList profileHistory={profileHistory} setProfileHistory={setProfileHistory} />

            }

            {/* Profile Submission */}
            {
                showSubmission && (


                    <div className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center  ">
                        <div className="bg-white p-6 rounded-lg w-full space-y-2 max-w-xl m-2  overflow-y-scroll max-h-[500px]">
                            <h3 className="text-xl text-center  font-semibold text-primary-400">Profile Submission</h3>
                            <ProfileSubmission candidateId={candidateId} jobId={jobId} BeURL={BeURL} showAlert={showAlert} processType={processType} setShow={setShowSubmission} refreshProfiles={fetchProfiles} />

                        </div>
                    </div >
                )
            }
        </div >
    );
};
